import { FormattedMessage } from 'react-intl';
import { Tag as AntdTag } from 'antd';

import Icon from '../../../components/Icon/Icon';
import Spinner from '../../../components/Spinner/Spinner';

import useArticlesTab from './useArticlesTab';

import { Props,TabStatus } from './ArticlesTab.model';

import styles from './ArticlesTab.module.scss';

const ArticlesTab = ({ i18nCountries, id }: Props) => {

  const {
		state: {
			articles,
			tabStatus,
		}
	} = useArticlesTab({ id });
	
  const renderChips = (chips: string[]) => {
    return chips.map((field: string, index: number) => (<AntdTag
      key={`${field}${index}`}
      style={{
        border: 'none',
        textTransform: 'uppercase'
      }}>{field}</AntdTag>))
	}
	
  return (
		<div className={styles.tabContent}>
			<Spinner spinning={tabStatus === TabStatus.Loading} />
	
			{articles.map((article) => (<div className={styles.article} key={article.articleId}>
				<div className={styles.icon}>
					<Icon name="file-alt" color="white" width="12px" height="16px" />
				</div>
				<div className={styles.articleContent}>
					<h2>{article.title}</h2>
					<i>{article.authors.map((author: string, index: number) => <span key={`author${index}`}>{author}{index !== article.authors.length - 1 && ', '}</span>)}</i> <br />
					<div>{renderChips(article.tags)}</div>
					<b>{article.publishedIn}, {article.publishingLocation ? `${i18nCountries[article.publishingLocation]},` : ''} {article.publishingYear}</b>
					<p>{article.description}</p>
					<div><a href={article.link} rel="noreferrer" target="_blank"><FormattedMessage id="userLabels.seeArticle" /></a></div>
				</div>
			</div>))}
			{tabStatus === TabStatus.Loaded && !articles?.length && <p className={styles.emptyContent}><FormattedMessage id="emptyContent.articles"/></p>}
		</div>
	);
}

export default ArticlesTab;